import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { DressCacheReducer } from "../reducers/DressCacheReducer";

const DressCacheContext = createContext({
	state: DressCacheReducer.getInitialState(),
	actions: DressCacheReducer.actions,
});

export const useDressCacheContext = () => useContext(DressCacheContext);

export const DressCacheProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: DressCacheReducer.getInitialState(),
		reducers: DressCacheReducer.caseReducers,
	});
	return (
		<DressCacheContext.Provider value={{ state, actions }}>
			{children}
		</DressCacheContext.Provider>
	);
};
